export function centerIntoView(elementId: string) {
  document.getElementById(`${elementId.toUpperCase()}`)?.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "center",
  });
}
